import { WorkflowOrganizerProps } from "interfaces/workflows/WorkflowOrganizerProps";
import { useState } from "react";
import { WorkflowsList } from "./WorkflowsList";
import { utilities } from "utils/utilities";
import WorkflowCreator from "./WorkflowCreator";
import { ApiService } from "services/ApiService";
import { WorkflowViewer } from "./WorkflowViewer";
import { Workflow } from "models/workflows/Workflow";

export const WorkflowOrganizer: React.FC<WorkflowOrganizerProps> = ({ ownerId }) => {
    const [selectedWorkflowId, setSelectedWorkflowId] = useState<string>("");
    const [selectedWorkflow, setSelectedWorkflow] = useState<Workflow>();
    const [isEditing, setIsEditing] = useState<boolean>(false);

    const handleCreateNew = () => {
        setSelectedWorkflowId(utilities.DEFAULT_GUID);
        setIsEditing(true);
    };

    const handleWorkflowSelectionClick = (workflowId: string) => {
        console.log("Selected workflow:" + workflowId);
        setSelectedWorkflowId(workflowId);
        setIsEditing(false);
    };

    const handleEditClick = (workflow: Workflow) => {
        setSelectedWorkflowId(workflow.id);
        setSelectedWorkflow(workflow);
        setIsEditing(true);
    };

    return (
        <div className="min-h-screen bg-gray-100 p-4">
            <div className="container mx-auto">
                <div className="bg-white p-6 rounded-lg shadow-lg">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">Workflow Organizer</h1>
                    <div className="flex flex-col lg:flex-row">
                        <div className="flex-1 lg:mr-4 mb-4 lg:mb-0">
                            {!isEditing && (
                                <WorkflowsList
                                    ownerId={ownerId}
                                    onCreateNew={handleCreateNew}
                                    onSelect={handleWorkflowSelectionClick}
                                />
                            )}
                        </div>
                        <div className="flex-1">
                            {isEditing && (
                                <WorkflowCreator
                                    ownerId={ownerId}
                                    workflow={selectedWorkflow ?? new Workflow(false, utilities.DEFAULT_GUID, "Blank Workflow")}
                                />
                            )}
                            {!isEditing && selectedWorkflowId && (
                                <WorkflowViewer
                                    workflowId={selectedWorkflowId}
                                    onEditClick={handleEditClick}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkflowOrganizer;